import { z } from "zod";
/**
 * Строка `v_corp_balances` (контракт v2.0 §4.2; только ADMINISTRATOR, D14) — читаются только нужные колонки.
 * Имена — snake_case, как у view (WP-DSP-1 §3.1), не как ключи записи `corp_company_update`.
 */
export const zCompanyFinanceRowDto = z.object({
    company_id: z.string(),
    name: z.string(),
    status: z.string(),
    credit_limit: z.number(),
    billing_period: z.string(),
    invoice_issue_day: z.number(),
    payment_term_days: z.number(),
    vat_rate: z.number().nullish(),
    balance: z.number(),
    available_credit: z.number(),
    total_charged: z.number(),
    total_paid: z.number(),
    open_orders_count: z.number(),
    open_orders_exposure: z.number(),
    overdue_amount: z.number(),
    overdue_invoices_count: z.number(),
    last_invoice_date: z.string().nullable(),
    last_payment_date: z.string().nullable(),
});
/** Все 18 колонок `v_corp_balances` (контракт v2.0 §4.2). Второго читателя этой view не создавать. */
export const COMPANY_FINANCE_COLUMNS = "company_id,name,status,credit_limit,billing_period,invoice_issue_day,payment_term_days,vat_rate,balance,available_credit,total_charged,total_paid,open_orders_count,open_orders_exposure,overdue_amount,overdue_invoices_count,last_invoice_date,last_payment_date";
